const fixFactorSquared = 2, fixFactor = Math.sqrt(fixFactorSquared), sides = 4, double = 2;
export class SquareDrawer {
    draw(data) {
        const { context, radius } = data, fixedRadius = radius / fixFactor, fixedDiameter = fixedRadius * double;
        context.rect(-fixedRadius, -fixedRadius, fixedDiameter, fixedDiameter);
    }
    getSidesCount() {
        return sides;
    }
}
